import axios from "axios";
import LocalStorageService from "@/common/LocalStorageService";
import router from "@/router";

const localStorageService = LocalStorageService.getService();

export default {
  install: function (Vue, params = {}) {

    // Add a request interceptor
    axios.interceptors.request.use(
        async config => {
            config.headers['Content-Type'] = 'application/json';
            return config;
        },
        error => {
            Promise.reject(error)
        });
    
    }
}
